import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type EventProps = {
  conversationId: number
  identityId: number
  isFirstInteraction: boolean
  requestId: string
  has: boolean
  sessionId: string
  nextInfo: any
  nextEventInfo: any
}

const initialState = {
  conversationId: 0,
  identityId: 0,
  isFirstInteraction: false,
  has: true,
  requestId: '',
  sessionId: '',
  nextInfo: {},
  nextEventInfo: {},
} as EventProps

// const root = 'http://mock.ixiaochuan.cn/mock/412'
export const openEvent = createAsyncThunk<any, any>(
  'openEvent',
  async (arg, store) => {
    return req(
      '/xai_start_event',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const sendChat = createAsyncThunk<any, any>(
  'sendChat',
  async (arg, store) => {
    return req(
      '/xai_chat',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getNextEvent = createAsyncThunk<any, any>(
  'getNextEvent',
  async (arg, store) => {
    return req(
      '/xai_get_event_next_step',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root,
      arg.signal
    )
  }
)

export const restartEvent = createAsyncThunk<any, any>(
  'restartEvent',
  async (arg, store) => {
    return req(
      '/xai_event_restart',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const repeattEvent = createAsyncThunk<any, any>(
  'repeattEvent',
  async (arg, store) => {
    return req(
      '/xai_event_chat_repeat',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)
export const inputEvent = createAsyncThunk<any, any>(
  'inputEvent',
  async (arg, store) => {
    return req(
      '/xai_chat_event',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const backTracking = createAsyncThunk<any, any>(
  'backTracking',
  async (arg, store) => {
    return req(
      '/xai_event_chat_backtracking',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getEventStatus = createAsyncThunk<any, any>(
  'getEventStatus',
  async (arg, store) => {
    return req(
      '/xai_character_status',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const updateBackgroundMusicStatus = createAsyncThunk<any, any>(
  'updateBackgroundMusicStatus',
  async (arg, store) => {
    return req(
      '/xai_update_background_music_status',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(openEvent.fulfilled, (state, action) => {
      return {
        ...state,
        nextInfo: {},
        nextEventInfo: {},
        ...action.payload,
      }
    })
    builder.addCase(getNextEvent.fulfilled, (state, action) => {
      return {
        ...state,
        nextInfo: action.payload,
      }
    })
    builder.addCase(restartEvent.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    builder.addCase(getEventStatus.fulfilled, (state, action) => {
      return {
        ...state,
        nextEventInfo: action.payload?.nextEventInfo,
      }
    })
    builder.addCase(inputEvent.fulfilled, (state, action) => {
      return {
        ...state,
        requestId: action.payload?.requestId,
      }
    })
    builder.addCase(backTracking.fulfilled, (state, action) => {
      return {
        ...state,
        sessionId: action.payload?.sessionId,
        requestId: action.payload?.requestId,
      }
    })
  },
})

export default eventSlice.reducer
